import { t } from 'i18next';
export var COUNTRIES = [
    { id: 1, name: t('countries.austria'), value: 'AT' },
    { id: 2, name: t('countries.canada'), value: 'CA' },
    { id: 3, name: t('countries.czech_republic'), value: 'CZE' },
    { id: 4, name: t('countries.germany'), value: 'DE' },
    { id: 5, name: t('countries.denmark'), value: 'DK' },
    { id: 7, name: t('countries.finland'), value: 'FI' },
    { id: 8, name: t('countries.united_kingdom'), value: 'UK' },
    { id: 9, name: t('countries.ireland'), value: 'IE' },
    { id: 10, name: t('countries.iceland'), value: 'ISL' },
    { id: 11, name: t('countries.poland'), value: 'PL' },
    { id: 12, name: t('countries.sweden'), value: 'SE' },
    { id: 13, name: t('countries.slovakia'), value: 'SVK' },
    { id: 14, name: t('countries.united_states'), value: 'US' },
];
export var POSTAL_CODE_FORMATS = {
    AT: { format: '9999', example: '1010' },
    CA: { format: 'A9A 9A9', example: 'K1A 0B1' },
    CZE: { format: '999 99', example: '110 00' },
    DE: { format: '99999', example: '10115' },
    DK: { format: '9999', example: '2100' },
    UK: { format: 'AA9A 9AA', example: 'SW1A 1AA' },
    FI: { format: '99999', example: '00100' },
    IE: { format: 'Eircode (A65 F4E2)', example: 'D02 X285' },
    ISL: { format: '999', example: '101' },
    PL: { format: '00-000', example: '00-950' },
    SE: { format: '999 99', example: '114 55' },
    SVK: { format: '999 99', example: '811 01' },
    US: { format: '99999 lub 99999-9999', example: '90210, 12345-6789' },
};
export var getPostalMask = function (countryCode) {
    var map = {
        PL: '00-000',
        AT: '0000',
        DK: '0000',
        DE: '00000',
        FI: '00000',
        CZE: '000 00',
        SE: '000 00',
        SVK: '000 00',
        ISL: '000',
        US: '00000[-0000]',
        CA: 'A0A 0A0',
        UK: undefined,
        IE: undefined,
    };
    return map[countryCode];
};
export var getPostalRegex = function (countryCode) {
    var map = {
        PL: /^\d{2}-\d{3}$/,
        AT: /^\d{4}$/,
        DK: /^\d{4}$/,
        DE: /^\d{5}$/,
        FI: /^\d{5}$/,
        CZE: /^\d{3}\s?\d{2}$/,
        SE: /^\d{3}\s?\d{2}$/,
        SVK: /^\d{3}\s?\d{2}$/,
        ISL: /^\d{3}$/,
        US: /^\d{5}(-\d{4})?$/,
        CA: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,
        UK: /^[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}$/i,
        IE: /^[A-Za-z]\d{2}\s?[A-Za-z0-9]{4}$/,
    };
    return map[countryCode];
};
